import React, { useEffect, useState } from "react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";
import { fetchDiscounts } from "../../api/dataService";

export default function Banner() {
  const [showBanner, setShowBanner] = useState(true);
  const [bannerText, setBannerText] = useState("");
  const [earliestExpirationDiscount, setEarliestExpirationDiscount] =
    useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleDismissBanner = () => {
    setShowBanner(false);
  };

  useEffect(() => {
    const loadDiscounts = async () => {
      try {
        setIsLoading(true);
        const dbDiscounts = await fetchDiscounts();
        const comparisonDate = new Date();

        // Get all valid discounts (both general and event-specific)
        const validDiscounts = dbDiscounts.filter((discount) => {
          const hasValidExpiration =
            discount.expirationDate &&
            new Date(discount.expirationDate) > comparisonDate;

          const isVisible = discount.isShowable !== false;

          return isVisible && hasValidExpiration;
        });

        // Separate general and event-specific discounts
        const generalDiscounts = validDiscounts.filter(
          (discount) => !discount.eventId
        );
        const eventDiscounts = validDiscounts.filter(
          (discount) => discount.eventId
        );

        // Helper function to find the earliest expiring discount
        const findEarliestExpiring = (discounts) => {
          return discounts.reduce((earliestDiscount, discount) => {
            const expirationDate = new Date(discount.expirationDate);
            if (
              !earliestDiscount ||
              expirationDate < new Date(earliestDiscount.expirationDate)
            ) {
              return discount;
            }
            return earliestDiscount;
          }, null);
        };

        // Prioritize general discounts, fall back to event-specific
        let nextExpiringDiscount = null;

        if (generalDiscounts.length > 0) {
          nextExpiringDiscount = findEarliestExpiring(generalDiscounts);
        } else if (eventDiscounts.length > 0) {
          nextExpiringDiscount = findEarliestExpiring(eventDiscounts);
        }

        console.log("General Discounts:", generalDiscounts);
        console.log("Event Discounts:", eventDiscounts);
        console.log("Selected Discount:", nextExpiringDiscount);

        if (!nextExpiringDiscount) {
          setEarliestExpirationDiscount(null);
          setShowBanner(false);
        } else {
          setEarliestExpirationDiscount(nextExpiringDiscount);
          setBannerText(nextExpiringDiscount.description);
          setShowBanner(true);
        }
        
        setIsLoading(false);
      } catch (error) {
        console.error("Failed to load discounts:", error);
        setShowBanner(false);
        setIsLoading(false);
      }
    };

    loadDiscounts();
  }, []);

  if (isLoading || !showBanner || !earliestExpirationDiscount) {
    return null;
  }

  return (
    <div className="flex absolute z-30 w-full items-center gap-x-6  bg-ttOrange-500 px-6 py-1 sm:px-1 sm:before:flex-1">
      <p className="text-sm leading-6 text-white">
        {earliestExpirationDiscount.description}
          {/* <svg
            viewBox="0 0 2 2"
            className="mx-2 inline h-0.5 w-0.5 fill-current"
            aria-hidden="true"
          >
            <circle cx={1} cy={1} r={1} />
          </svg> */}
          <span className="ml-2">
            <Link to="/reservations">
              <strong className="font-semibold">
                Use code {earliestExpirationDiscount.code} at checkout!
              </strong>
            </Link>
          </span>
        </p>
        <div className="flex flex-1 justify-end">
          <button
            type="button"
            onClick={() => setShowBanner(false)}
            className="p-2 focus:outline-none"
          >
            <span className="sr-only">Dismiss</span>
            <XMarkIcon className="h-5 w-5 text-white" aria-hidden="true" />
          </button>
        </div>
      </div>
    );
}
